/** OPEN on the wire: never build a `z.enum(...)` from these without a `.catch(...)`. */
export const PROGRESS_CHART_KIND = {
  GOAL: "goal",
  SYMPTOM_GROUP: "symptom_group",
  QUALITY_OF_LIFE: "quality_of_life",
  UNKNOWN: "unknown",
} as const;

export const PROGRESS_STATUS_CODE = {
  GETTING_EASIER: "getting_easier",
  IMPROVING: "improving",
  HOLDING: "holding",
  WATCHING: "watching",
  JUST_STARTED: "just_started",
  UNKNOWN: "unknown",
} as const;

/** `ATTENTION` is the only tone allowed to render red. */
export const PROGRESS_STATUS_TONE = {
  POSITIVE: "positive",
  NEUTRAL: "neutral",
  ATTENTION: "attention",
  UNKNOWN: "unknown",
} as const;

export const PROGRESS_STATUS_FALLBACK = {
  [PROGRESS_STATUS_CODE.GETTING_EASIER]: {
    label: "Getting Easier",
    tone: PROGRESS_STATUS_TONE.POSITIVE,
  },
  [PROGRESS_STATUS_CODE.IMPROVING]: { label: "Improving", tone: PROGRESS_STATUS_TONE.POSITIVE },
  [PROGRESS_STATUS_CODE.HOLDING]: { label: "Holding", tone: PROGRESS_STATUS_TONE.NEUTRAL },
  [PROGRESS_STATUS_CODE.WATCHING]: { label: "Watching", tone: PROGRESS_STATUS_TONE.ATTENTION },
  [PROGRESS_STATUS_CODE.JUST_STARTED]: {
    label: "Just Started",
    tone: PROGRESS_STATUS_TONE.NEUTRAL,
  },
} as const;

export const PROGRESS_BETTER_DIRECTION = {
  LOWER: "lower",
  HIGHER: "higher",
  UNKNOWN: "unknown",
} as const;

export const PROGRESS_DATA_STATE = {
  OK: "ok",
  NO_CHECK_INS: "no_check_ins",
  NO_BASELINE: "no_baseline",
  NOT_SCORED: "not_scored",
  UNKNOWN: "unknown",
} as const;

export const PROGRESS_SEVERITY_BAND = {
  MILD: "mild",
  MODERATE: "moderate",
  SEVERE: "severe",
} as const;

export const PROGRESS_BASELINE_SOURCE = {
  PROFILING: "profiling",
  UNKNOWN: "unknown",
} as const;

/** `CHECK_INS_REPORTING` counts check-ins that reported an event, NOT the events themselves. */
export const PROGRESS_OUTCOME_COUNT_BASIS = {
  CHECK_INS_REPORTING: "check_ins_reporting",
  UNKNOWN: "unknown",
} as const;

/** Lowest and highest value of each metric class, mirrored from the backend. */
export const PROGRESS_SCALE = {
  GOAL: { min: 1, max: 10, step: 1 },
  SYMPTOM_GROUP: { min: 1, max: 5, step: 1 },
  QUALITY_OF_LIFE: { min: 1, max: 5, step: 1 },
} as const;
